import { createFileRoute } from '@tanstack/react-router';
import { AdminDashboardPage } from '@/features/admin/admin-dashboard-page';

export const Route = createFileRoute('/sales/')({
  component: SalesDashboardRoute,
});

function SalesDashboardRoute() {
  return <AdminDashboardPage portalBase="/sales" />;
}
